import { routes } from '../config/api_routes'

export const ChowmanPayService = {

    getChowmanPay: (formData) => window.axios.post(routes.getChowmanPayApi,formData),
    chowmanPayExportCsv: (formData) => window.axios.post(routes.chowmanPayExportToCsvApi, formData),
    getPay: (id) => window.axios.post(routes.getTheChowman, {id: id}),
    refundPayment: (formData) => window.axios.post(routes.chowmanPayRefundPaymentApi, formData),
    
}